<!-- Breadcrumbs Section -->
<div class="mt-16 px-6 lg:ml-10">
  <dhp-breadcrumbs
    class="text-sm text-secondary-text"
    [crumbs]="breadcrumbItems()"
  ></dhp-breadcrumbs>
</div>

<!-- Error Section -->
@if (error()) {
  <div class="mt-8 px-6 text-center lg:px-16">
    <div class="rounded-md bg-error-light p-4">
      <p class="text-base text-error-text">
        {{ error() ?? '' | translate }}
      </p>
    </div>
  </div>
}

<!-- Loading Section -->
@if (isLoadingMore()) {
  <div class="flex flex-col items-center justify-center space-y-4 py-12">
    <div
      class="h-10 w-10 animate-spin rounded-full border-4 border-primary-border/30 border-t-primary-border"
    ></div>
    <p class="text-secondary-text">
      {{ 'common.loading.default' | translate }}
    </p>
  </div>
}

<!-- Author Details Section - Using Main Info Component -->
@if (person() && !error()) {
  <div class="px-4 pt-6 lg:px-16 lg:pt-10">
    <dhp-main-info [person]="person()!"></dhp-main-info>
  </div>
}

<!-- Publications Section with Lazy Loading -->
@if (!error()) {
  <div
    class="mt-20 mb-20 px-4 lg:px-16"
    [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="70"
    [infiniteScrollDisabled]="isLoadingMore() || !hasMoreItems()"
    [alwaysCallback]="true"
    [immediateCheck]="true"
    (scrolled)="onScroll()"
    infiniteScroll
  >
    <!-- Publication Content -->
    <div class="w-full">
      <h2 class="mb-4 text-3xl font-medium text-primary-text">
        {{
          'pages.authors.publicationsInMagazine'
            | translate: { count: totalArticles() }
        }}
      </h2>
      <hr class="mb-6 border-neutral-300" />
      @if (adaptedArticles().length) {
        <dhp-article-list
          [articles]="adaptedArticles()"
          [embedContext]="'authorDetails'"
        ></dhp-article-list>
        <!-- Loading More Indicator -->
        @if (isLoadingMore()) {
          <div class="mt-4 text-center">
            <div
              class="border-primary mx-auto h-8 w-8 animate-spin rounded-full border-t-2 border-b-2"
            ></div>
          </div>
        }
      } @else {
        <div class="py-8 text-center text-base text-secondary-text">
          {{ 'pages.authors.errors.noArticles' | translate }}
        </div>
      }
    </div>
  </div>
}

<!-- Subscriptions Section -->
@if (!error()) {
  <dhp-our-subscriptions></dhp-our-subscriptions>
}
